import { ROUTES } from '../routes/paths';

export const Paths = {
  Company: 'Company',
  Customer: 'Customer',
  Supplier: 'Supplier',
  toCompany: ROUTES.company.details,
  toCustomer: ROUTES.customers.details,
  toSupplier: ROUTES.suppliers.details,
  toLegalCounsel: ROUTES.legalCounsel.details,
  addCompany: '/addCompany',
  addCustomer: '/addCustomer',
  addSupplier: '/addSupplier',
  addLegalCounsel: '/add',
  compliance: ROUTES.compliance.details,
  pto: ROUTES.time.timeOff,
  customerDocument: ROUTES.customers.documents,
  supplierDocument: ROUTES.suppliers.documents,
  companyDocument: ROUTES.company.hrDocuments,
  companyDocumentTemplates: ROUTES.company.documentTemplates,
}

export const ComponentNames = {
  Company: 'Company',
  Customer: 'Customer',
  Supplier: 'Supplier',
  LegalCounsel: 'Legal Counsel',
}

export const CountryCodes = {
  IndiaCode: 'IND'
}

export const FileExtensions = {
  Pdf: 'pdf',
  Md: 'md'
}

export const Involvedpartyrole = {
  AddTeam: 5,
  Company: 2,
  Customer: 3,
};

export const ConnectionType = {
  Company: 'COMPANY',
  Customer: 'CUSTOMER',
  Individual: 'INDIVIDUAL',
};

export const CodeSchemeNames = {
  CompanyDocumentPurpose: 'CompanyDocumentPurpose',
  SupplierDocumentPurpose: 'SupplierDocumentPurpose',
  CustomerDocumentPurpose: 'CustomerDocumentPurpose',
  CompanyAgreementStatus: 'CompanyAgreementStatus',
  DocumentDomain: 'DocumentDomain',
  CustomerAgreementStatus: 'CustomerAgreementStatus',
  SupplierAgreementStatus: 'SupplierAgreementStatus'
}

export const CodeGroup = {
  Config: 'Config',
  CardConfig: 'CardConfig'
}

export const AssignmentsRoles = {
  Package: 3,
};

export const InvolvedPartyRole = {
  INVL: 'INVL',
  COMPANY: 'COMPANY',
  CUSTOMER: 'CUSTOMER',
  SUPPLIER: 'SUPPLIER',
  EMPLOYEE: 'EMPLOYEE',
  LEGALCOUNSEL: 'LEGALCOUNSEL',
};

export const LocationPathName = {
  DocumentsTemplates: '/DocumentTemplates',
  PersonnelDocuments: '/Personnel-Documents',
};


export const StatusNames = {
  onboarding: 'onboarding',
  offboarding: 'offboarding',
  active: 'active',
  separated: 'seperated',
};

export const DocumentTemplateNames = {
  Config1: 'pageconfig1',
  Config2: 'pageconfig2',
};

export const ptoLifeCycleStatusConsts = {
  Rejected: 'REJECTED',
  Cancelled: 'CANCELLED',
  Approved: 'APPROVED',
  Pending: 'PENDING',
};

export const employeeStatus = {
  HR: 'HR',
  Employee: 'Employee',
  TeamLead: 'TeamLead',
  AlternativeTeamLead: 'AlternativeTeamLead',
  Admin: 'Admin',
  CustomerSignatory: 'CustomerSignatory',
  SupplierSignatory: 'SupplierSignatory',
  DocuCenterAdmin: 'DocuCenterAdmin',
  PeopleTeamAdministrator: 'PeopleTeamAdministrator',
  Administrator: 'Administrator',
  LegalAdministrator: 'LegalAdministrator',
	LegalCounsel: 'LegalCounsel',
	InternalCaseManager: 'InternalCaseManager',
	ExternalCaseManager: 'ExternalCaseManager',
  AccountsAdministrator: 'AccountsAdministrator',
  ITAdministrator: 'ITAdministrator',
  InternalSignatory: 'InternalSignatory',
  Counselor: 'Counselor',
  CounselorPanel: 'CounselorPanel',
  System: 'System',
};

export const roleLevels: { [key: string]: number } = {
  Admin: 1,
  Administrator: 2,
  PeopleTeamAdministrator: 3,
  AccountsAdministrator: 4,
  DocuCenterAdmin: 5,
  TeamLead: 6,
  Employee:7,
  ITAdministrator: 8,
  AlternativeTeamLead: 9,
  Counselor: 10,
  CounselorPanel: 11,
	LegalCounsel: 12,
	InternalCaseManager: 13,
	ExternalCaseManager: 14,
	CustomerSignatory: 15,
	SupplierSignatory: 16,
  InternalSignatory: 17,
  System: 18,
  LegalAdministrator: 19,
};


export const timeUnitConfig = {
  FullDay: 'Full Day',
  HalfDay: 'Half Day',
  MultipleDays: 'Multiple Days',
};

export const PTOWorkflowLifeCycleStatusDataConfig = {
  Approved: 'APPROVED',
  Escalated: 'ESCALATED',
  Rejected: 'REJECTED',
  Pending: 'PENDING',
  Cancelled: 'CANCELLED',
  PendingPeopleTeamCancellation: 'PENDINGPEOPLETEAMCANCELLATION',
  CancelledByEmployee: 'CANCELLEDBYEMPLOYEE'
};

export const FunctionalComponentsConfig = {
  PTO: 'PTO',
  COMPLIANCE: "COMPLIANCE",
  IMMIGRATION: "IMMIGRATION"
};

export const ProjectConst = {
  Project: 'Project',
};
export const WorkLevel = {
  Epic: 'Epic',
};
export const ProfileDocument = {
  SupplierSignatory: 'SupplierSignatory',
  CustomerSignatory: 'CustomerSignatory'
};

export const TimesheetLifecycleStatus = {
  NotStarted: 'NOTSTARTED',
  Draft: 'DRAFT',
  Submitted: 'SUBMITTED',
  Rejected: 'REJECTED',
  Approved: 'APPROVED',
  PendingApproval: 'PENDINGAPPROVAL',
  Edited: 'EDITED',
  NotSubmitted: 'NOTSUBMITTED',
  EditedByApprover: 'EDITEDBYAPPROVER',
  Recalled: 'RECALLED',
  PartiallyApproved: 'PARTIALLYAPPROVED',
  PublicHoliday: 'PUBLICHOLIDAY'
}
export const EmailTemplateStatus = {
  Draft: 'DRAFT',
  Active: 'ACTIVE'
}

export const IndividualDocumentStatus = {
  Acceptedbyuser: 'ACCEPTEDBYUSER',
  Submitted: 'SUBMITTED',
  RejectedByCompany: 'REJECTEDBYCOMPANY',
  AcceptedByCompany: 'ACCEPTEDBYCOMPANY'
}

export const ptoType = {
  GeneralLeave: 'GENERALLEAVE',
};

export const PTOPolicyLevelConfig = {
  Designation: 'DESIGNATION',
  Company: 'COMPANY',
};

export const EnvelopAssignmentLifeCycleStatus = {
  InForce: 'IN-FORCE',
  InProgress: 'IN-PROGRESS',
  Issued: 'ISSUED',
  Designation: 'DESIGNATION',
  Company: 'COMPANY',
};

export const DocumentTabNames = {
  InProgess: 'INPROGRESS',
}

export const WorkItemType = {
  AGILE: 'AGILE',
  BASIC: 'BASIC',
  TRADITIONAL: 'TRADITIONAL',
  CMMI: 'CMMI',
  SCRUM: 'SCRUM'
};

export const TableNames = {
  AuditLog: 'AuditLog',
}

export const EnvelopeParticipantRoleType = {
  SIGNER: 'SIGNER'
}
export const AddressTypeCode = {
  HomeAddress: 'HOMEADDRESS'//Home Address
}
export const ProfileJob = {
  active: 'Active',
  seperated: 'Seperated',
  Administrator: 'Administrator',
  PeopleTeamAdministrator: 'PeopleTeamAdministrator'
}

export const EnvelopeDeliverymethod = {
  Email: 'EMAIL'
}

export const LeaveType = {
  PublicHoliday: 'publicHoliday',
  leaveWithoutPay: 'LEAVEWITHOUTPAY',
}

export const WorkItemLevel = {
  Epic: 'Epic',
  Feature: 'Feature',
  Issue: 'Issue',
  ProductBacklogItem: 'Product backlog item',
  Requirement: 'Requirement',
  UserStory: 'User Story',
  Task: 'Task',
  PublicHoliday: 'Public Holiday',
  PTOHoliday: 'PTO'
}

export const ProjectFieldAction = {
  customer: 'CUSTOMER',
  organizationId: 'organizationId',
  projectLeadId: 'projectLeadId',
  projectLeadName: 'projectLeadName',
  alternateProjectLeadId: 'alternateProjectLeadId',
  alternateProjectLeadName: 'alternateProjectLeadName',
  projectName: 'projectName',
  projectCode: 'projectCode',
  description: 'description',
  startDate: 'startDate',
  endDate: 'endDate',
  practiceAreaId: 'practiceAreaId',
  practiceAreaName: 'practiceAreaName',
  clientOwnerName: 'clientOwnerName',
  isActive: 'isActive',
  isChargeable: 'isChargeable',
  isInternal: 'isInternal',
  forClaimsOnly: 'forClaimsOnly',
  isClone: 'isClone',
}

export const IndividualFieldAction = {
  workLocationId: 'workLocationId',
  startDate: 'startDate',
  workerTypeId: 'workerTypeId',
  departmentId: 'departmentId',
  workMode: 'workMode',
  designationId: 'designationId',
  employmentTypeId: 'employmentTypeId',
  employmentStatusId: 'employmentStatusId',
  FECycleId: 'feCycleId',
  counselorId: 'counselorId'
}

export const DisplayStatus = {
  Active: 'Active',
  InActive: 'InActive'
}

export const Status = {
  Active: 'ACTIVE'
}

export const AssetType = {
  Tangible: 'TANGIBLE'
}

export const ComplianceStatus = {
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  PartiallyApproved: 'PARTIALLYAPPROVED'
}

export const ComplianceCurrentStage = {
  TeamLead: 'TEAMLEAD'
}

export const EnumerationListsConfig = {
  PTOPolicyLevel: 'PTOPolicyLevel',
  PTOType: 'PTOType',
  PTOPolicyTimeUnit: 'PTOPolicyTimeUnit',
  PTORequestTimeUnit: 'PTORequestTimeUnit',
  PTOWorkflowLifeCycleStatus: 'PTOWorkflowLifeCycleStatus',
  PTOLifeCycleStatus: 'PTOLifeCycleStatus',
  EscalationType: 'EscalationType',
  EnvelopeParticipantRoleType: 'EnvelopeParticipantRoleType',
  EnvelopeDeliverymethod: 'EnvelopeDeliverymethod',
  OrganizationAddressTypeCode: 'OrganizationAddressTypeCode',
  IndividualAddressTypeCode: 'IndividualAddressTypeCode',
  Department: 'Department',
  WorkArrangementType: 'WorkArrangementType',
  InternalDesignation: 'InternalDesignation',
  EmploymentType: 'EmploymentType',
  EmploymentStatus: 'EmploymentStatus',
  AcademicQualificationType: 'AcademicQualificationType',
  ModeofEducation: 'ModeofEducation',
  ExternalDesignation: 'ExternalDesignation',
  TechnicalEnvironment: 'TechnicalEnvironment',
  TechnicalSkill: 'TechnicalSkill',
  PracticeArea: 'PracticeArea',
  ProjectWorkRole: 'ProjectWorkRole',
  DeliveryLocationType: 'DeliveryLocationType',
  //FunctionalModule: 'FunctionalModule',
  TemplateVariable: 'TemplateVariable',
  IndividualIdentificationType: 'IndividualIdentificationType',
  TaskPriority: 'TaskPriority',
  PageViewConfiguration: 'PageViewConfiguration',
  EscalateTo: 'EscalateTo',
  EngagementType: 'EngagementType',
  EnvelopeLifeCycleStatus: 'EnvelopeLifeCycleStatus',
  EnvelopAssignmentLifeCycleStatus: 'EnvelopAssignmentLifeCycleStatus',
  TaskAssignmentLifeCycleStatus: 'TaskAssignmentLifeCycleStatus',
  TimesheetLifecycleStatus: 'TimesheetLifecycleStatus',
  IndividualDocumentStatus: 'IndividualDocumentStatus',
  WorkItemType: 'WorkItemType',
  EligibleProjects: 'EligibleProjects',
  LeaveType: 'LeaveType',
  ProjectFieldAction: 'ProjectFieldAction',
  IndividualFieldAction: 'IndividualFieldAction',
  AssetCriticality: 'AssetCriticality',
  AssetState: 'AssetState',
  AssetCategory: 'AssetCategory',
  AssetType: 'AssetType',
  AssetUsageType: 'AssetUsageType',
  AssetSubCategory: 'AssetSubCategory',
  AssetStatus: 'AssetStatus',
  ITAssetCategory: 'IT-AssetCategory',
  FacilityAssetCategory: 'Facility-AssetCategory',
  MachineryAssetCategory: 'Machinery-AssetCategory',
  VehicleAssetCategory: 'Vehicle-AssetCategory',
  SoftwareAssetCategory: 'Software-AssetCategory',
  FurnitureAssetCategory: 'Furniture-AssetCategory',
  AssetAssignmentType: 'AssetAssignmentType',
  AssetAcquisitionMethod: 'AssetAcquisitionMethod',
  AssetDepreciationMethod: 'AssetDepreciationMethod',
  AssetDisposalMethod: 'AssetDisposalMethod',
  AssetMaintenanceFrequency: 'AssetMaintenanceFrequency',
  ITAttributesAssetCategory: 'IT-Attributes-AssetCategory',
  MachineryAttributesAssetCategory: 'Machinery-Attributes-AssetCategory',
  VehicleAttributesAssetCategory: 'Vehicle-Attributes-AssetCategory',
  SoftwareAttributesAssetCategory: 'Software-Attributes-AssetCategory',
  FacilityAttributesAssetCategory: 'Facility-Attributes-AssetCategory',
  FurnitureAttributesAssetCategory: 'Furniture-Attributes-AssetCategory',
  DateFormat: 'DateFormat',
  WorkerType: 'WorkerType',
  AssetMaintenanceType: 'AssetMaintenanceType',
  AssetComplianceChecks: 'AssetComplianceChecks',
  CurrencyType: 'CurrencyType',
  ComplianceRequestType: 'ComplianceRequestType',
  ComplianceRequestStatus: 'ComplianceRequestStatus',
  ComplianceCurrentStage: 'ComplianceCurrentStage',
  InvolvedPartyRoleType: 'InvolvedPartyRoleType',
  OrganizationRelationshipType: 'OrganizationRelationshipType',
  BankAccountType: 'BankAccountType',
  Gender: 'Gender',
  RoleType: 'RoleType',
  EmailTemplateStatus: 'EmailTemplateStatus',
  WorkflowActionInitiator: 'WorkflowActionInitiator',
  WorkflowEscalationType: 'WorkflowEscalationType',
  WorkflowEscalationTargetType: 'WorkflowEscalationTargetType',
  WorkflowEscalationAction: 'WorkflowEscalationAction',
  WorkflowRuleActions: "WorkflowRuleActions",
  Operators: "Operators",
  NotificationChannel: "NotificationChannel",
  MenuGroupType: 'MenuGroupType',
  WorkflowInstanceStatus: 'WorkflowInstanceStatus',
  InvoiceTimeApprovalStatus: 'InvoiceTimeApprovalStatus',
  ExpenseCategoryType: 'ExpenseCategoryType',
  PECycleStatus: 'PECycleStatus',
  PEGoalCategory: 'PEGoalCategory',
  PERatingScale: 'PERatingScale',
  FinancialEvaluationCycle: 'FinancialEvaluationCycle',
  PEFrequency: 'PEFrequency',
  EmployeeEvidenceType: 'EmployeeEvidenceType',
  ExpirationPolicy: 'ExpirationPolicy',
  EmployeeSourceNodeType: "EmployeeSourceNodeType",
  MetricLevel: "MetricLevel",
  UnitOfMeasure: "UnitOfMeasure",
  PromotionReadinessTier: "PromotionReadinessTier",
  ProjectNature: "ProjectNature",
  ProjectAllocationType: "ProjectAllocationType",
  BusinessUnit: "BusinessUnit",
  EnvelopeStorageType: "EnvelopeStorageType",
  DocumentDomains: "DocumentDomains",
  HRCategory: 'HR-Category',
  TeammemberCategory: 'Teammember-Category',
  CustomerCategory: 'Customer-Category',
  SupplierCategory: 'Supplier-Category',
  StandardTask: 'StandardTask',
  DimensionClassificationType: 'DimensionClassificationType',
  PriorityLevel: 'PriorityLevel',
  WorkflowStepType: "WorkflowStepType",
  WorksheetFieldType: "WorksheetFieldType",
  SecurityPartitionType: "SecurityPartitionType",
  ImmigrationCaseType: "ImmigrationCaseType",
  ImmigrationCaseStatus: "ImmigrationCaseStatus",
  InspectionDeliveryMode: "InspectionDeliveryMode",
	InspectionAction: "InspectionAction",
	ThresholdLevel: "ThresholdLevel",
	EvidenceValidator: 'EvidenceValidator',
  RequirementSetType: "RequirementSetType",
  RequirementType: "RequirementType",
  RequirementSetRelation: "RequirementSetRelation",
  WorkflowConditionEvaluationType: 'WorkflowConditionEvaluationType',
  WorkflowConditionPredicateSourceType: 'WorkflowConditionPredicateSourceType',
  WorkflowConditionInstanceStatus: 'WorkflowConditionInstanceStatus',
  WorkflowTransitionType: 'WorkflowTransitionType',
  WorkflowTransitionTriggerMechanism: 'WorkflowTransitionTriggerMechanism',
  SignatureType: 'SignatureType'
};

export const WorkflowConditionEvaluationType = {
  EXCEPTION_BRANCH: 'EXCEPTION_BRANCH'
}

export const SignatureType = {
  TYPE: 'TYPE',
  DRAW: 'DRAW',
  IMAGE: 'IMAGE'
}

export const InspectionDeliveryMode = {
  PORTAL: 'PORTAL'
}

export const RequirementType = {
  Document: 'DOCUMENT',
  Worksheet: 'WORKSHEET',
  Attestation: 'ATTESTATION',
  Acknowledgment: 'ACKNOWLEDGMENT',
  Signature: 'SIGNATURE'
}

export const InspectionAction = {
  Download: 'DOWNLOAD',
  View: 'VIEW',
  Complete: 'COMPLETE'
}

export const SecurityPartitionType = {
  PUBLIC: 'PUBLIC',
  PAF_PUBLIC_ACCESS: 'PAF_PUBLIC_ACCESS'
}

export const WorkflowStepType = {
	Document: "DOCUMENT",
	WorkSheet: "WORKSHEET"
}

export const DocumentDomains = {
  HR: 'HR',
  Teammember: 'Teammember',
  TeammemberCode: 'TEAMMEMBER',
  Customer: 'Customer',
  Supplier: 'Supplier'
}

export const DocumentCategoryDomains = {
  HR: 'HR',
  Teammember: 'TEAMMEMBER',
  Customer: 'CUSTOMER',
  Supplier: 'SUPPLIER',
  Immigration: 'IMMIGRATION'
}

export const WorkFlowStepDefinitionCodes = {
  BackgroundCollection: 'BACKGROUND_COLLECTION',
  Closed: 'CLOSE'
}

export const ExpirationPolicy = {
  StrictExpiration: 'STRICTEXPIRATION'
};

export const WorkflowInstanceStatus = {
  Completed: "COMPLETED",
  Pending: "PENDING",
  NotStarted: "NOTSTARTED",
  NotApplicable: "NOTAPPLICABLE",
  Superseded: "SUPERSEDED",
  InProgress: "INPROGRESS",
  Closed: 'CLOSED',
}

export const WorkflowActions = {
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Reviewed: "REVIEWED",
  Issued: "ISSUED",
  Signed: "SIGNED"
}

export const WorkflowActionInitiator = {
  User: "USER",
  System: "SYSTEM"
}

export const ProjectWorkRole = {
  TeamLead: 'TeamLead',
}
export const OrganizationRelationshipType = {
  Parent: 'PARENT',
  Customer: 'CUSTOMER',
  Supplier: 'SUPPLIER',
  LegalCounsel: 'LEGALCOUNSEL'
}

export const Channel = {
  Email: "EMAIL"
}

export const codeValueNames = {
  CustomerSignatoryAddress: 'CustomerSignatoryAddress',
  SupplierSignatoryAddress: 'CustomerSignatoryAddress'
}

export const UrlRoutes = {
  customer_CustomerDocuments: ROUTES.customers.documents,
  company_HRDocuments: ROUTES.company.hrDocuments,
  company_DocumentTemplates: ROUTES.company.documentTemplates,
  suppliers_SupplierDocuments: ROUTES.suppliers.documents,
  splitHrDocument: 'HRDocuments',
  splitSupplierDocuments: 'SupplierDocuments',
  splitDocumentTemplates: 'DocumentTemplates',
  splitCustomerDocuments: 'CustomerDocuments',
}

export const ComplianceRequestType = {
  ASSETOFFCAMPUS: 'ASSETOFFCAMPUS',
  WORKFROMHOME: 'WORKFROMHOME'
}

export const WorkflowEscalationTargetType = {
  user: "USER",
  role: "ROLE",
  system: "SYSTEM"
}

export const InvoiceTimeApprovalStatus = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Rejected: 'REJECTED',
  Reviewed: 'REVIEWED',
  Submitted: 'SUBMITTED',
}

export const OrganizationSignleViewSecurityTabs = {
  Title: "Security Audit",
  Description: "All documents are encrypted and access is logged for compliance.",
  ViewAccessLogs: "View Access Logs",
  AccessLogs: "Access Logs",
  backToDocuments: "Back to Repository"
}

export const PEFrequency = {
  HalfYearly: 'HALF_YEARLY',
  Quarterly: 'QUARTERLY',
  Annually: 'ANNUALLY'
}

export const FinancialEvaluationCycle = {
  Q1: 'MAR',
  Q2: 'JUN',
  Q3: 'SEP',
  Q4: 'DEC'
}

export const employeeSourceNodeTypeConst = {
  Customer: 'CUSTOMER',
  Peer: 'PEER',
  Self: 'SELF'
}

export const DeliveryLocationType = {
  AllRegions: "ALL_REGIONS"
}

export const InternalDesignation = {
  AllLevels: 'ALL_LEVELS'
}

export const ProjectAllocationType = {
  AllLevels: 'ALL_LEVELS'
}

export const ProjectNatureType = {
  AllNatures: 'ALL_NATURES'
}

export const PromotionalReadiness = {
  AllCandiates: 'ALL_CANDIDATES'
}

export const BusinessUnit = {
  All: 'ALL'
}

export const PERatingScale = {
  Five: '5'
}


export const PECycles = {
  ALL: 'ALL'
}


export const DimensionTypes = {
  Unknown: 'UNKNOWN'
}

export const UnknownCodeValue = {
  Unknown: -1
}

export const MetricCodes = {
  BillableContribHours: 'BILLABLE_CONTRIB_HOURS',
	OverallRatingMatrics: 'OVERALL_RATING_MATRIX',
	UnknownMetric: 'UNKNOWN_METRIC'
}

export const onBoardingWorkflowSteps = {
  HR_POLICY_ALLOCATION: "HR_POLICY_ALLOCATION",
  PTO_RULES: "PTO_RULES",
  PROJECT_ALLOCATION: "PROJECT_ALLOCATION",
  IT__LOGISTICS: "IT__LOGISTICS",
  CLOSE: "CLOSE"
}


export const DimensionClassificationType = {
  ProjectBased: 'PROJECT_BASED'
}

export const workflowDefinitionType = {
  IMMIGRATION_COMPLIANCE: "IMMIGRATION_COMPLIANCE",
  H1B_WORKFLOW: "H1B_WORKFLOW",
}

export const ImmigrationComplainceType = {
  ImmigrationCases: 'ImmigrationCases',
  WorkflowEngineGovernance:'WorkflowEngineGovernance',
  PublicAccessFiles: 'PublicAccessFiles',
  MasterFolderCategories: 'MasterFolderCategories',
  HelpGuides: 'HelpGuides',
}
export const ImmigrationCasesType = {
  DashboardDirectory: 'DashboardDirectory',
  ImmigrationCases: 'ImmigrationCases'
}

export const PublicAccessFilesType = {
  Dashboard: 'Dashboard',
  PreparePaf: 'PreparePaf',
  DashboardSnapshots: 'DashboardSnapshots',
  PortalSandbox: 'PortalSandbox',
  SessionHistory: 'SessionHistory'
}

export const ManageWorkflowType = {
  WorkflowReminders: 'WorkflowReminders',
  WorkflowEngineRoadmap: 'WorkflowEngineRoadmap',
  WorksheetsForms: 'WorksheetsForms',
  GRCFileVault: 'GRCFileVault',
  CaseAuditLog: 'CaseAuditLog'
}

export const WorksheetFormsOwnershipResponsibilityType = {
  SponsorCorporate: 'SponsorCorporate',
  CandidateProfile: 'CandidateProfile',
  PositionStrategy: 'PositionStrategy',
  PublicDisclosureAudit: 'PublicDisclosureAudit'
}

export const StepsOwnershipActionsTypes = {
  AllRoles: 'AllRoles',
  SponsoringEmployer: 'SponsoringEmployer',
  Candidate: 'Candidate',
  LegalCounsel: 'LegalCounsel',
  SystemAutomation: 'SystemAutomation'
}

export const PriorityLevel = {
  High: "High",
  Medium: "Medium",
  Low: "Low"
}

export const FieldType = {
  STRING: "STRING",
  TEXTAREA: "TEXTAREA",
  NUMBER: "NUMBER",
  DECIMAL: "DECIMAL",
  DATE: "DATE",
  BOOLEAN: "BOOLEAN",
  CHECKBOX: "CHECKBOX",
  FILE: "FILE",
  SELECT: "SELECT",
}

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export const GrcMasterVaultTabs = {
  All: "All",
  PAF: "PAF",
  CONFIDENTIAL: "CONFIDENTIAL"
}

export const functionModule = {
  IMMIGRATION: "IMMIGRATION",
}

export const ThresholdLevel = {
	DimensionLevel: 'DIMENSION_LEVEL',
	MetricLevel: 'METRIC_LEVEL',
	OverallCycle: 'OVERALL_CYCLE'
}
